import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

import { AddNotes } from '../Illustrations/AddNotes';

export const DisabledPanel = () => (
  <Box
    sx={{
      mt: 8,
      mx: 'auto',
      textAlign: 'center',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
      alignContent: 'center',
    }}
  >
    <AddNotes />
    <Typography gutterBottom variant="body1">
      Le contenu de cet onglet est désactivé.
    </Typography>
  </Box>
);
